import Markdown from '@portals/shared-frontend/components/Markdown';
import { useMemo } from 'react';

import { extractLinks } from '@/components/Guide/GuideTableOfContent';
import { HeroContent } from '@/components/HeroPage/HeroContent';
import HeroMenu from '@/components/HeroPage/HeroMenu';
import { NavigationMenu } from '@/components/NavigationMenu';

interface Props {
  content: string;
}

export function HeroPageGuide({ content }: Props) {
  const navigationItems = useMemo(() => {
    return extractLinks(content).map((link) => ({
      displayName: link.name,
      slug: link.key,
    }));
  }, [content]);

  return (
    <>
      <HeroMenu noPadding>
        <NavigationMenu items={navigationItems} />
      </HeroMenu>
      <HeroContent>
        <Markdown>{content}</Markdown>
      </HeroContent>
    </>
  );
}
